var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("PageEditorModal", {
        directives: [
          { name: "show", rawName: "v-show", value: true, expression: "true" }
        ],
        attrs: {
          id: "edit-page-editor-modal",
          page: _vm.page,
          "is-shown": true
        },
        on: { "page-added": _vm.onPageAdded, cancel: _vm.cancelPageEdit }
      }),
      _vm._v(" "),
      _c("MathEditorModal", {
        attrs: { id: "math-editor-modal" },
        on: { add: _vm.addMath }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-50e37d9e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50e37d9e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/edit-page/views/EditPage.vue
// module id = c6YG
// module chunks = 1